import { commonServerInstance } from '@/utilities/instances'

/**
 *
 * @param {string} period_start
 * @param {string} period_end
 * @returns {{
 *  data: Array<{
 *    warehouse_id: number
 *    airport_code: string
 *    adj_amount: number
 *  }>
 * }}
 */

export function getDriverPaymentAdjustments(period_start, period_end) {
  const formData = new FormData()
  formData.append('period_start', period_start)
  formData.append('period_end', period_end)
  return commonServerInstance
    .post('api/v1/payment-adjustment/search', formData)
    .then(({ data }) => data.data)
}

/**
 *
 * @param {string} period_start
 * @param {string} period_end
 * @param {file} file
 * @returns {{
 *  file_id: string
 *  data: Array<{
 *    warehouse_id: number
 *    airport_code: string
 *    adj_amount: number
 *  }>
 *  warnings: Array<string>
 *  errors: Array<string>
 * }}
 */
export function addDriverPaymentAdjustments(period_start, period_end, file) {
  const formData = new FormData()
  formData.append('period_start', period_start)
  formData.append('period_end', period_end)
  formData.append('file', file)
  return commonServerInstance
    .post('api/v1/payment-adjustment', formData)
    .then(({ data }) => data.data)
}

/**
 *
 * @param {string} file_id
 * @returns
 */
export function deleteDriverPaymentAdjustments(file_id) {
  return commonServerInstance
    .delete(`api/v1/payment-adjustment/${file_id}`)
    .then(() => undefined)
}
